/**
 * Profile Styles - Shared constants and helper styles
 * 
 * This file contains shared styling constants for all profile components.
 * Follows the same pattern as loginStyles.js for consistency.
 */
import { FOCUS_BORDER, getFocusBorder, FOCUS_CONFIG } from "../../../config/focusStyles";

// Profile-specific color palette
export var PROFILE_COLORS = {
  background: "#121212",
  cardBg: "#212121",
  cardGradientStart: "#2A2A2A",
  cardGradientEnd: "#1A1A1A",
  sectionBg: "rgba(255, 255, 255, 0.05)",
  border: "rgba(255, 255, 255, 0.1)",
  accent: "#EF4444",
  accentHover: "#DC2626",
  accentLight: "rgba(239, 68, 68, 0.2)",
  text: "#FFFFFF",
  textSecondary: "#BFBFBF",
  textMuted: "rgba(255, 255, 255, 0.5)",
  focusRing: "#F5F5F5",
  buttonBg: "#262626",
  buttonHover: "#333333",
  danger: "#6A0000",
  dangerHover: "#800000",
  success: "#006A37",
  successHover: "rgb(0, 90, 50)",
  warning: "rgba(255, 255, 255, 0.3)",
  divider: "#FFFFFF",
};

// Typography sizes
export var PROFILE_FONT_SIZES = {
  title: "28px",
  subtitle: "24px",
  body: "22px",
  small: "20px",
  tiny: "18px",
  avatar: "26px",
};

// Font family
export var FONT_FAMILY = "'AnjomanMax', sans-serif";

// Spacing
export var PROFILE_SPACING = {
  xs: "8px",
  sm: "12px",
  md: "16px",
  lg: "24px",
  xl: "32px",
  xxl: "48px",
};

// Border radius
export var PROFILE_RADIUS = {
  sm: "12px",
  md: "16px",
  lg: "20px",
  xl: "24px",
  round: "50%",
};

// Focus border for TV navigation (using global config)
export var PROFILE_SHADOWS = {
  focusBorder: function (color) {
    return getFocusBorder(color || PROFILE_COLORS.focusRing, '4px');
  },
  // Alias for backward compatibility - consumers should migrate to focusBorder
  focusInset: function (color) {
    return getFocusBorder(color || PROFILE_COLORS.focusRing, '4px');
  },
  active: FOCUS_BORDER.active,
  none: FOCUS_BORDER.inactive,
};

// Avatar sizes
export var AVATAR_SIZES = {
  large: {
    width: "75px",
    height: "75px",
  },
  medium: {
    width: "64px",
    height: "64px",
  },
  small: {
    width: "48px",
    height: "48px",
  },
};

// Icon unicode characters (for legacy TV compatibility)
export var ICONS = {
  bookmark: "📑",
  history: "⏱️",
  subscription: "📋",
  logout: "🚪",
  cart: "🛒",
  check: "✓",
  warning: "⚠️",
  user: "👤",
};
